import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['latitude', 'longitude', 'status']

  share (event) {
    event.preventDefault()

    if (!navigator.geolocation) {
      this.showStatus('Location is not supported on this device.')
      return
    }

    this.showStatus('Getting your location…')

    navigator.geolocation.getCurrentPosition(
      (position) => {
        this.latitudeTarget.value = position.coords.latitude
        this.longitudeTarget.value = position.coords.longitude
        this.showStatus('')
        this.element.requestSubmit()
      },
      (error) => {
        const message = error.code === error.PERMISSION_DENIED
          ? 'Location permission denied. Allow location access in your browser settings.'
          : (error.message || 'Could not get your location.')
        this.showStatus(message)
      },
      { enableHighAccuracy: true, timeout: 15_000, maximumAge: 0 }
    )
  }

  showStatus (message) {
    if (!this.hasStatusTarget) return

    this.statusTarget.textContent = message
    this.statusTarget.classList.toggle('hidden', !message)
  }
}
